const { SWITCH_MODE_REQUEST, SWITCH_MODE_SUCCESS, SWITCH_MODE_FAILURE } = require('../../lib/constants').default;

const isChangingMode = (state = false, action = {}) => {
  switch (action.type) {
    case SWITCH_MODE_REQUEST:
      return true;
    case SWITCH_MODE_SUCCESS:
    case SWITCH_MODE_FAILURE:
      return false;
    default:
      return state;
  }
};

export default (state = {}, action = {}) => ({
  isChangingMode: isChangingMode(state.isChangingMode, action),
});
